import React, { useEffect, useState } from 'react';
import { Table, Spin, message, Button, Tooltip, Popconfirm, Checkbox,Typography } from 'antd';
import { BASE_URL,DateTimeFormat,DateFormat } from '../Components/Constant';
import ApiService from '../Components/apiService';
import { DownOutlined, EditOutlined, CopyOutlined, DeleteOutlined } from '@ant-design/icons';
import CreateTabDrawer from './CreateTabDrawer'; // Import the CreateTabDrawer component
import eventBus from '../Components/eventBus';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import {convertDateToUserTimezone} from '../Components/Utility';


const { Title } = Typography;

const CustomTabs = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false); // State to manage drawer visibility
  const[tabDataForEdit,setTabDataForEdit] = useState('');
  const [objectNames,setObjectNames] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [customComponentNames, setCustomComponentNames] = useState([]);
  const security = useSelector((state) => state.data.items[0]);

  

  const fetchTabsData = async () => {
    setLoading(true);
    const apiService = new ApiService(`${BASE_URL}/mt_tabs`, {
      'Content-Type': 'application/json',
    }, 'GET');

    try {
      const response = await apiService.makeCall();
       // Enrich tab data with object name
      const enrichedData = response.map(tab => ({
        ...tab,
        objectName: objectNames[tab.mt_object_id] || 'N/A',
      }));

      setData(enrichedData);
    } catch (err) {
      setError(err);
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to fetch tabs due to an unknown error';
      message.error(errorMessage);
    }
    finally {
      setLoading(false);
    }
  };

  const fetchObjectNames = async ()=>{
    try{
      const apiService = new ApiService(`${BASE_URL}/mt_objects`, {
                'Content-Type': 'application/json',
              }, 'GET');
      const objectResponse = await apiService.makeCall();
        // Convert array to object with _id as key for faster lookup
      const objectMap = objectResponse.reduce((acc, obj) => {
        acc[obj._id] = obj.name; // Storing only name for quick access
        return acc;
      }, {});

      setObjectNames(objectMap);
    }catch(error){
      console.log('error',error);
    }
  }
  // const fetchObjectNames = async (tabsData) => {
  //   // Use Promise.all to fetch object names for each tab's mt_object_id
  //   const promises = tabsData.map(async (tab) => {
  //     if (tab.mt_object_id) {
  //       const apiService = new ApiService(`${BASE_URL}/mt_objects/${tab.mt_object_id}`, {
  //         'Content-Type': 'application/json',
  //       }, 'GET');
  //       try {
  //         const objectResponse = await apiService.makeCall();
  //         return { ...tab, objectName: objectResponse.name }; // Enrich the tab data with object name
  //       } catch (err) {
  //         console.error(`Error fetching object for ${tab.mt_object_id}:`, err);
  //         return { ...tab, objectName: 'N/A' }; // If the API call fails, set a default value
  //       }
  //     }
  //     return { ...tab, objectName: 'N/A' }; // Default value if no mt_object_id
  //   });

  //   return Promise.all(promises);
  // };



  const fetchCustomComponents = async () => {

      try {
        const res = await fetch(`${BASE_URL}/plugins/get_names`);
        const names = await res.json();   
        setCustomComponentNames(names);
      } catch (error) {
        console.error('Error fetching custom components', error);
      }

  }
  useEffect(() => {
    fetchObjectNames();
    fetchCustomComponents();
  }, []);

  useEffect(() => {
    if (Object.keys(objectNames).length > 0) {
      fetchTabsData();
    }
  }, [objectNames]); // Only fetch tabs after objects are loaded
  
  const deleteTab = async (tab) => {
    if(security?.system_settings?.objects.delete===false){
      message.error('You dont have permission to delete ');
      return;
    }

    try {
      setLoading(true);
      const apiService = new ApiService(
        `${BASE_URL}/mt_tabs/${tab._id}`,
        {}, // Headers (if any)
        'DELETE'
      );

      await apiService.makeCall();
      fetchTabsData();
      // eventBus.emit('objectCreatedOrUpdated'); 
      message.success('Record deleted successfully.');
    } catch (error) {
      message.error('Failed to delete record.');
      console.error('Error deleting record:', error);
    }
    finally{
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Label',
      dataIndex: 'label',
      key: 'label',
      sorter: (a, b) => a.label.localeCompare(b.label), // Sorting for Label
      
    },
    {
      title: 'API Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name), // Sorting for API Name
    },
    {
      title: 'Object Name', // New column for object name
      dataIndex: 'objectName',
      key: 'objectName',
      sorter: (a, b) => a.objectName.localeCompare(b.objectName), // Sorting for Object Name
    },
    {
      title: 'Active',
      dataIndex: 'active',
      key: 'active',
      width: 100,
      render: (active) => (
        <Checkbox checked={active} disabled />
      ),
    },
    {
      title: 'Tab Order',
      dataIndex: 'order',
      key: 'order',
      width: 100,
      sorter: (a, b) => a.order - b.order,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      // width: 100,
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (text) => (
        text && dayjs(text).isValid()
          ? convertDateToUserTimezone(text, DateTimeFormat)
          : ''
      ),
    },



    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      // width: 100,
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (text) => (
        text && dayjs(text).isValid()
          ? convertDateToUserTimezone(text, DateTimeFormat)
          : ''
      ),
    },




  ];

  columns.push(
    {
    title: 'Action',
    key: 'operation',
    render: (_, record) => (
      <> 
        <Tooltip title="Edit">
          <EditOutlined
            onClick={() => handleEdit(record)}
            style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
          />
        </Tooltip>
        <Tooltip title="Delete">
          <Popconfirm
            title="Are you sure you want to delete this item?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => {
              deleteTab(record)
            }
            }

          >
            <DeleteOutlined style={{ color: 'red', marginRight: 5, fontSize: '12px', cursor: 'pointer' }} />
          </Popconfirm>
        </Tooltip>
      </>
    ),
  }
);
  
 const handleEdit = (tabData)=>{

  if(security?.system_settings?.objects.edit===false){
              message.error('You dont have permission to edit ');
              return;
            }
  
  setTabDataForEdit(tabData);
  setDrawerVisible(true);
  }
  const closeDrawer = () => {
    setTabDataForEdit(null);
    setDrawerVisible(false);
  }
  return (
    <div >
        <Spin size="large" tip="Loading..." spinning={loading}>
      
        <Table 
         title={() => (
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Title level={4} >Custom Tabs</Title>
                        <Button type="primary" onClick={() => {
        if(security?.system_settings?.objects.create===false){
          message.error('You dont have permission to create ');
          return;
        }

      setDrawerVisible(true)}
      }
        >Create Tab
      </Button>
        
        
        
                      </div>
                    )}
        style={{marginTop:'10px'}}
         dataSource={data} 
         columns={columns} 
         rowKey="id" 
         scroll={{ x: 'max-content',y: 550 }}
          pagination={{
              pageSize: pageSize,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              onChange: (page, pageSize) => {
                setPageSize(pageSize);
              },              
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }} />
        </Spin>

      <CreateTabDrawer 
      fetchTabsData={fetchTabsData} 
      tabData={tabDataForEdit} 
      visible={drawerVisible} 
      onClose={closeDrawer}
      loading={loading}
      setLoading={setLoading}
      customComponents ={customComponentNames}
       /> {/* Render the drawer */}

    </div>
  );
};

export default CustomTabs;
